import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

import { ViewUtils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';

// -- constants
import ViewConstants from 'constants/ViewConstants';

// -- entities
import ProductCategory from 'PMT/entities/menu/ProductCategory';

// -- views
import EnabledDisabledIcon from 'PMT/components/EnabledDisabledIcon';
import RowPricesView from 'components/order/RowPricesView';
import SortableList from 'PMT/components/SortableList';
import ImageLoader from 'PMT/components/ImageLoader';

class CategoryDetailChildCategoryRow extends Component {

  static propTypes = {
    category: PropTypes.instanceOf(ProductCategory).isRequired,

    // parameters: Menu
    onDeleteFromCategory: PropTypes.func.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.category.equals(this.props.category);
  }

  onDisplayDetail = () => {
    RouteAction.presentCategoryDetail(this.category);
  };

  onDeleteFromCategory = () => {
    this.props.onDeleteFromCategory(this.props.category);
  };

  get category(): ProductCategory {
    return this.props.category;
  }

  renderAvailabilities() {
    // no availitbilities for a category.
    return (
      null
    );
  }

  render() {
    return (
      <div className="product_category_view__row child_category_row pointer row">

        <div className="hidden-sm col-md-2 text-left">
          <ImageLoader
            src={this.category.image}
            className="product_category_view__row__image"
            placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY}
          />
        </div>

        <div
          className="category__name col-xs-6 product_category_view__row__name"
          onClick={this.onDisplayDetail}
        >
          <h4>{this.category.name}</h4>
        </div>

        <div
          className="pointer col-xs-2 text-right"
          onClick={this.onDisplayDetail}
        >
          {this.renderAvailabilities()}
        </div>

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer col-xs-1 text-center product_category_view__row__remove"
            onClick={this.onDeleteFromCategory}
          >
            <i className="fa fa-trash" />
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer col-xs-1 text-center product_category_view__row__drag"
          >
            <SortableList.DragHandle />
          </div>
        }
      </div>
    );
  }

}

export default CategoryDetailChildCategoryRow;
